import { Directive, OnInit } from '@angular/core';
import { Application } from '@modules/common/types/application';
import { VirtualFolder } from '@modules/messages/types/virtual-folder';
import { StateKey } from '@modules/settings/types/state-key';
import { MessagesContextMenuComponent } from '../components/messages-context-menu/messages-context-menu.component';
import { DPContextMenuDirective } from './dp-context-menu.directive';

@Directive({
  selector: '[appDPMessagesContextMenu]',
  standalone: false,
})
export class MessagesContextMenuDirective
  extends DPContextMenuDirective<VirtualFolder, MessagesContextMenuComponent>
  implements OnInit
{
  protected override readonly application = Application.mail;
  protected override readonly stateKey = StateKey.messagesDPSidebarFilters;

  protected override registerComponent() {
    return MessagesContextMenuComponent;
  }
}
